import axios from 'axios';

export async function getInviteStatus(facilityId) {
    try {
      const response = await axios.get(`${process.env.VUE_APP_OS_API_URL}/v1/os/invitation-status`, {
        params: {
          facility_id: facilityId
        },
        headers: {
          'x-api-key': 'acomodev'
        }
      });
      return response.data;
    } catch (error) {
      console.error('API call failed:', error);
      throw error;
    }
}